import HTML from '../../assets/image/html5.svg';
import CSS from '../../assets/image/css3.svg';
import SASS from '../../assets/image/sass.svg';
import JS from '../../assets/image/js.svg';
import TS from '../../assets/image/typescript.svg';
import React from '../../assets/image/react.svg';
import Redux from '../../assets/image/redux.svg';
import Jest from '../../assets/image/jest.svg';
import Axios from '../../assets/image/axios.png';
import MaterialUI from '../../assets/image/material-ui.svg';
import GIT from '../../assets/image/git.svg';
import Storybook from '../../assets/image/storybook.svg';
import RestAPI from '../../assets/image/rest-api.png';
import Postman from '../../assets/image/postman.svg';
import Formik from '../../assets/image/formik.png';
import Socket from '../../assets/image/socket.svg';

export const skillsData = [
    {
        id: '1',
        title: 'React',
        description: 'JavaScript-based UI development library.',
        backgroundImage: `url(${React})`,
    },
    {
        id: '2',
        title: 'Redux',
        description: ' JavaScript library for managing and centralizing application state.',
        backgroundImage: `url(${Redux})`,
    },
    {
        id: '3',
        title: 'TypeScript',
        description: 'A syntactic superset of JavaScript which adds static typing.',
        backgroundImage: `url(${TS})`,
    },
    {
        id: '4',
        title: 'JavaScript',
        description: 'The Programming Language for the Web that conforms to the ECMAScript specification.',
        backgroundImage: `url(${JS})`,
    },
    {
        id: '5',
        title: 'HTML',
        description: 'Hypertext Markup Language for describing the contents and appearance of Web pages.',
        backgroundImage: `url(${HTML})`,
    },
    {
        id: '6',
        title: 'CSS',
        description: 'Stylesheet language used to describe the presentation of a document written in HTML.',
        backgroundImage: `url(${CSS})`,
    },
    {
        id: '7',
        title: 'SASS',
        description: 'CSS preprocessor, which adds special features such as variables, nested rules and mixins into regular CSS.',
        backgroundImage: `url(${SASS})`,
    },
    {
        id: '8',
        title: 'Jest',
        description: 'JavaScript library for creating, running, and structuring tests.',
        backgroundImage: `url(${Jest})`,
    },
    {
        id: '9',
        title: 'Rest API',
        description: 'Architectural style for an application program interface (API) that uses HTTP requests to access and use data.',
        backgroundImage: `url(${RestAPI})`,
    },
    {
        id: '10',
        title: 'Axios',
        description: 'Promise-based library used with Node.js and browser to make asynchronous JavaScript HTTP requests.',
        backgroundImage: `url(${Axios})`,
    },
    {
        id: '11',
        title: 'Postman',
        description: 'API platform for building and using APIs',
        backgroundImage: `url(${Postman})`,
    },
    {
        id: '12',
        title: 'Material UI',
        description: 'Library that allows import and use different components to create a user interface in React applications.',
        backgroundImage: `url(${MaterialUI})`,
    },
    {
        id: '13',
        title: 'Storybook',
        description: 'Tool for building UI components and pages in isolation.',
        backgroundImage: `url(${Storybook})`,
    },
    {
        id: '14',
        title: 'GIT',
        description: 'DevOps tool used for source code management.',
        backgroundImage: `url(${GIT})`,
    },
    {
        id: '15',
        title: 'Formik',
        description: 'Small group of React components and hooks for building forms in React and React Native.',
        backgroundImage: `url(${Formik})`,
    },
    {
        id: '16',
        title: 'Socket.io',
        description: 'Library that enables low-latency, bidirectional and event-based communication between a client and a server. ',
        backgroundImage: `url(${Socket})`,
    },
]